import { CircleCheckIcon, Clock3Icon, ShieldCheckIcon } from "lucide-react";
import { useOutletContext } from "react-router";
import { PortalPageHeader, PortalPageShell } from "../components/PortalProduct";
import type { PortalWorkspaceContext } from "../components/PortalWorkspaceLayout";

const getFirstName = (fullName: string) => fullName.trim().split(/\s+/)[0] || "there";

/** Renders the static landing page for tenant team members in the partner portal. */
const TenantTeamMemberHomePage = () => {
  const { actor } = useOutletContext<PortalWorkspaceContext>();

  return (
    <PortalPageShell width="max-w-5xl">
      <div className="space-y-3">
        <PortalPageHeader
          title={`Welcome back, ${getFirstName(actor.fullname)}`}
          meta="Team member workspace"
          description="Your available portal tools and shared work appear here."
        />
        <section className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-[0_1px_2px_rgba(19,27,42,0.04)]">
          <div className="border-b border-gray-200 bg-[#FBFBFB] px-4 py-3">
            <span className="inline-flex items-center gap-2 text-xs font-semibold text-(--brand-primary)">
              <ShieldCheckIcon size={14} strokeWidth={1.8} /> Secure workspace access
            </span>
          </div>
          <div className="grid gap-3 p-4 sm:grid-cols-3">
            {[
              {
                icon: CircleCheckIcon,
                title: "Account active",
                description: "Your portal session is secure and ready to use.",
              },
              {
                icon: Clock3Icon,
                title: "More tools soon",
                description: "Your available workspace features will appear here.",
              },
              {
                icon: ShieldCheckIcon,
                title: "Protected access",
                description: "Only features assigned to your role are shown.",
              },
            ].map(({ icon: Icon, title, description }) => (
              <article key={title} className="rounded-lg border border-gray-200 bg-[#FBFBFB] p-4">
                <Icon size={18} className="text-(--brand-primary)" strokeWidth={1.8} aria-hidden="true" />
                <h2 className="mt-3 text-sm font-semibold text-[#131B2A]">{title}</h2>
                <p className="mt-1.5 text-xs leading-5 text-gray-500">{description}</p>
              </article>
            ))}
          </div>
        </section>
      </div>
    </PortalPageShell>
  );
};

export default TenantTeamMemberHomePage;
